import { render, staticRenderFns } from "./gen.vue?vue&type=template&id=50365567&scoped=true"
import script from "./gen.vue?vue&type=script&lang=js"
export * from "./gen.vue?vue&type=script&lang=js"
import style0 from "./gen.vue?vue&type=style&index=0&id=50365567&prod&lang=css"
import style1 from "./gen.vue?vue&type=style&index=1&id=50365567&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50365567",
  null
  
)

/* custom blocks */
import block0 from "./gen.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

export default component.exports